import { render, staticRenderFns } from "./AssignBoothEdit.vue?vue&type=template&id=26da98dd&scoped=true"
import script from "./AssignBoothEdit.vue?vue&type=script&lang=ts"
export * from "./AssignBoothEdit.vue?vue&type=script&lang=ts"
import style0 from "./AssignBoothEdit.vue?vue&type=style&index=0&id=26da98dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26da98dd",
  null
  
)

export default component.exports